import Column from '@components/Column';
import Divider from '@components/Divider';
import PgAccordion from '@components/order/PgAccordion';
import TermNotes from '@components/term/TermNotes';
import styled from '@emotion/styled';

import Banner from './components/Banner';
import PrepaidCard from './components/PrepaidCard';
import ProductGiftRecommend from './components/ProductGiftRecommend';

function GiftMainFragment() {
    return (
        <Column fullWidth>
            <Container fullWidth>
                <Banner/>
                <PrepaidCard/>
                <ProductGiftRecommend/>
            </Container>
            <Divider/>
            <TermNotes displayContext='GIFT' />
        </Column>
    );
}

const Container = styled(Column)`
    padding: 0 0 32px;
`;

export default GiftMainFragment;
